import * as XLSX from 'xlsx-js-style';
import { withHeaderStyling } from '../../../utils';
import {
  InvestorCapitalAccountDTO,
} from '../../../../financial-statement/models/DTOs/capital-account/InvestorCapitalAccountDTO';
import { CapitalAccountData }
  from '../../../../financial-statement/utils/capital-account/utils';
import { CapitalAccountMapper } from './capital-account.mapper';
import { InvestorCapitalAccount } from '../../../../financial-statement/models/capital-account/InvestorCapitalAccount';
import { ExcelTemplate, Rows } from '../../../interfaces';
import { ItemManualValueData } from './item-manual-values-parser';

export class CapitalAccountTemplate implements ExcelTemplate {
  public static investorHeaders = ['ID', 'Name', 'GP', 'Commitment'];
  private mapper: CapitalAccountMapper;

  constructor() {
    this.mapper = new CapitalAccountMapper();
  }

  export(capitalAccountData: CapitalAccountData): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getCapitalAccountSheet(capitalAccountData);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  exportInvestors(investors: InvestorCapitalAccount[], orgId: number, fundId: string): void {
    const book = XLSX.utils.book_new();
    const sheet = this.getInvestorsSheet(investors, orgId, fundId);
    XLSX.utils.book_append_sheet(book, sheet);
    XLSX.writeFile(book, 'CapitalAccountInvestorsTemplate.xlsx');
  }

  importInvestors(data: unknown[]): InvestorCapitalAccountDTO[] {
    return this.mapper.mapExcelDataToInvestors(data);
  }

  importManualValues(data: Rows): ItemManualValueData[] {
    return this.mapper.mapExcelDataToManualValues(data);
  }

  getCapitalAccountSheet(capitalAccountData: CapitalAccountData): XLSX.WorkSheet {
    return withHeaderStyling(this.mapper.prepareData(capitalAccountData));
  }

  private getInvestorsSheet(investors: InvestorCapitalAccount[], orgId: number, fundId: string): XLSX.WorkSheet {
    let templateData;
    if (investors.length) {
      templateData = [
        CapitalAccountTemplate.investorHeaders,
        ...this.mapper.mapInvestorsToTemplateData(investors),
      ];
    } else {
      templateData = [
        CapitalAccountTemplate.investorHeaders,
        ...this.mapper.createTemplateData(orgId, fundId),
      ];
    }

    const sheet = {
      ...XLSX.utils.aoa_to_sheet(templateData),
      '!cols': investorColumnWidths,
    };
    return withHeaderStyling(sheet);
  }
}

const investorColumnWidths = [
  { width: 12 },
  { width: 24 },
  { width: 12 },
  { width: 12 },
];
